import Attendance from './Attendance';
import TravelOptions from './TravelOptions';
import DietaryRequirements from './DietaryRequirements';

function RsvpMember({ member, index, showName, onUpdate }) {
  const content = (
    <>
      <Attendance
        attending={member.attending}
        name={`attendance-${index}`}
        onChange={(value) => onUpdate({ attending: value })}
      />

      {member.attending && !member.isNightDo && <TravelOptions
        travel={member.travel}
        name={`travel-${index}`}
        onChange={(value) => onUpdate({ travel: value })}
      />}

      {member.attending && <DietaryRequirements
        dietary={member.dietary}
        dietaryOther={member.dietaryOther}
        name={`dietary-${index}`}
        onChange={(updates) => onUpdate({ dietary: updates.dietary, dietaryOther: updates.dietaryOther })}
      />}
    </>
  );

  if (showName) {
    return (
      <details className="rsvp-accordion">
        <summary className="josefin-slab rsvp-accordion-summary">
          {member.firstName} {member.lastName}
        </summary>
        {content}
      </details>
    );
  }

  return content;
}

export default RsvpMember;
